import { Select, SelectProps, MenuItem, Box, Typography, FormControl, InputLabel, useMediaQuery, Theme } from '@mui/material';
import { FC, useState } from 'react';
import { palette } from '@/theme/constants';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

interface IAditionalProps {
  name: string;
  placeholder?: string;
  options?: any;
  handleSelect: any;
  value: string;
  width?: any;
  marginRight?: any;
  error?: boolean | any;
  fontSize?: any;
  errorMessage?: string | any;
  isDarkTheme?: boolean;
  RightAlign?: any;
  label?: string;
  disabled?: boolean;
  defaultValue?: string;
  hideArrow?: boolean;
}

type Props = SelectProps | IAditionalProps;

export const MuiSelect: FC<Props> = ({
  name,
  options,
  handleSelect,
  marginRight ='1rem',
  RightAlign = false,
  value,
  width,
  error = false,
  errorMessage = '',
  fontSize,
  label,
  placeholder,
  disabled,
  defaultValue,
  hideArrow = false,
}: any) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  return (
    <FormControl fullWidth error={error} variant='standard' sx={{ width:  width, marginRight: hideArrow  ? '-1rem' : '0rem'}}>
      {label && (
        <InputLabel
          id={`${name}-label`}
          shrink
          sx={{
            color: '#5C6372',
            '&.Mui-focused': { color: '#5C6372' },
            '&.Mui-error.Mui-focused': { color: 'red' },
          }}>
          {label}
        </InputLabel>
      )}
      <Select
        id={name}
        name={name}
        value={value}
        disabled={disabled}
        defaultValue={defaultValue ?? ''}
        sx={{
          width,
          backgroundColor: 'transparent',
          color: '#5C6372',
          fontSize: fontSize,
          textAlign: RightAlign ? 'right': 'left',
          boxShadow: 'none',
         
          border: 'none',
          '&.MuiOutlinedInput-root': {
            '& fieldset': { border: 'none' },
            '&:hover fieldset': { border: 'none' },
            '&.Mui-focused fieldset': { border: 'none' },
          },
          '&.MuiInputBase-root::before': { borderBottom: 'none !important' },
          '&.MuiInputBase-root::after': { borderBottom: 'none !important' },
          '&.MuiInputBase-root:hover::before': { borderBottom: 'none !important' },
          ...(hideArrow && {
            '& .MuiSelect-icon': {
              display: 'none',
            },
          }),
        }}
        onChange={handleSelect}
        displayEmpty
        MenuProps={{
          PaperProps: {
            sx: {
              marginLeft:'-1.5rem',
              backgroundColor: '#D8E8F6 !important', // Sets the entire dropdown background to black
              color: 'black', // Ensures text is readable
            },
          },
        }}
        >
        {placeholder && (
          <MenuItem
            sx={{
              backgroundColor: '#D8E8F6 !important',

              '&:hover': {
                backgroundColor: '#0072CE',
              },
              '&.Mui-focusVisible': {
                backgroundColor: '#0072CE',
              },
              '&.Mui-selected': {
                backgroundColor: '#0072CE !important',
                color: 'white',
              },
            }}
            value=''
            disabled>
            {placeholder}
          </MenuItem>
        )}
        {options?.map((item: any) => (
          <MenuItem
            sx={{
              backgroundColor: '#D8E8F6',
              fontSize: fontSize,
              '&:hover': {
                backgroundColor: '#0072CE',
              },
              '&.Mui-focusVisible': {
                backgroundColor: '#0072CE',
              },
              '&.Mui-selected': {
                backgroundColor: '#0072CE !important',
                color: 'white',
              },
            }}
            key={item.value}
            value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
      {error && <Typography color='red'>{errorMessage}</Typography>}
    </FormControl>
  );
};
